import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./HomePage.css";

import placeholder from "../assets/placeholder.jpeg"; // Placeholder image for recipes
import poultry_pic from "../assets/poultry.png";
import redmeat_pic from "../assets/red_meats.png";
import seafood_pic from "../assets/seafood.png";
import vegetables_pic from "../assets/vegetables.png";
import fruits_pic from "../assets/fruits.png";
import dairy_pic from "../assets/dairy.png";
import grains_pic from "../assets/grains.png";

const seriesList = [
  { name: "Chinese Takeout at Home"}
  // { name: "Ramadan Recipes", image: placeholder },
  // { name: "Easy Weeknight Meals", image: placeholder },
  // { name: "Comfort Food", image: placeholder },
  // { name: "Desserts Galore", image: placeholder },
];

const ingredientsList = [
  {name: "poultry", image: poultry_pic }, // chicken, other birds
  {name: "red meats", image: redmeat_pic }, // beef, mutton, lamb, etc
  {name: "seafood", image: seafood_pic },
  {name: "vegetables", image: vegetables_pic },
  {name: "fruits", image: fruits_pic },
  {name: "dairy & eggs", image: dairy_pic },
  {name: "grains", image: grains_pic },
];

function HomePage() {
  const [featured, setFeatured] = useState([]);
  const [scrollIndex, setScrollIndex] = useState(0);
  const [seriesImages, setSeriesImages] = useState({});

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/recipes/`, {
        params: { featured: true, page_size: 8 },
      })
      .then((res) => setFeatured(res.data.results));
  }, []);

  useEffect(() => {
    // For each series, euqry one recipe that belongs to the series to get an image)
    async function fetchSeriesImages() {
      let imagesMap = {};

      for (const s of seriesList) {
        try { 
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/recipes/`,
            { params: { series: s.name, page_size: 1 } }
          );

          const firstRecipe = res.data.results[0];

          imagesMap[s.name] = firstRecipe?.images?.[0]?.image_url || placeholder;
        } catch (error) {
          imagesMap[s.name] = placeholder;
        }
      }
      setSeriesImages(imagesMap);
    }
    fetchSeriesImages();
  }, []);

  const visibleSeries = seriesList.slice(scrollIndex, scrollIndex + 4);

  return (
    <div className="homepage">
      {/* Featured Section */}
      <section className="featured-section">
        <h2>Featured Recipes</h2>
        <div className="featured-grid">
          {featured.map((recipe) => (
            <Link to={`/recipes/${recipe.id}`} className="featured-card" key={recipe.id}>
              <img
                src={recipe.images?.[0]?.image_url || placeholder}
                alt={recipe.title}
              />
              <h4>{recipe.title}</h4>
            </Link>
          ))}
        </div>
        <Link to="/recipes" className="browse-button">
          Browse All Recipes
        </Link>
      </section>

      {/* Explore by Series Section */}
      <section className="series-section">
        <h2>Explore by Series</h2>
        <div className="series-carousel">
          {scrollIndex > 0 && (
            <button onClick={() => setScrollIndex((i) => i - 1)}>&lt;</button>
          )}
          <div className="series-row">
            {visibleSeries.map((s, index) => (
              <Link to={`/series/${encodeURIComponent(s.name)}`} className="series-card" key={index}>
                <img src={seriesImages[s.name] || placeholder} alt={s.name} />
                <p>{s.name}</p>
              </Link>
            ))}
          </div>
          {scrollIndex + 4 < seriesList.length && (
            <button onClick={() => setScrollIndex((i) => i + 1)}>&gt;</button>
          )}
        </div>
      </section>

      {/* Explore by Ingredients Section */}
      <section className="ingredients-section">
        <h2>Explore by Ingredients</h2>
        <div className="ingredient-circles">
          {ingredientsList.map((ingredient, index) => (
            <div className="circle-card" key={index}>
              <img src={ingredient.image} alt={ingredient.image} />
              <p>{ingredient.name}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default HomePage;
